import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
@Component({
  selector: 'app-benefist-card',
  imports: [],
  templateUrl: './benefist-card.component.html',
  styleUrl: './benefist-card.component.scss',
})
export class BenefistCardComponent {
  @Input() nombre!: string;
  @Input() descripcion!: string;
  @Input() imagen!: string;
  @Input() idMarca!: string;
  
  get descripcionTruncada(): string {
    const isMobile = window.innerWidth <= 768;
    const maxLength = isMobile ? 20 : 100;
    return this.descripcion?.length > maxLength 
      ? this.descripcion.substring(0, maxLength) + '...'
      : this.descripcion;
  }
  
  /**
   *
   */
  constructor(private router: Router) {}

  goToBenefistInfo() {
    this.router.navigate(['/benefitsInfo'], { queryParams: { idMarca: this.idMarca } });
  }
}
